import { render } from "./OtcInstallSection.vue?vue&type=template&id=3baa1f0d"
import script from "./OtcInstallSection.vue?vue&type=script&lang=js"
export * from "./OtcInstallSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__